module.exports = __webpack_public_path__ + "img/logo.b33f5273.png";